import { getNamespace } from '../utils/namespace'

export default {
  /* 获取微信签名 */
  getWeiXinAuth: {
    path: getNamespace() + '/api/wx/jsskd/auth',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/apis/weixin.js